import { translations } from 'translations';

export const FIELD_FLAGS = [
  translations.INPUTS.TEXT_FIELD_FORM_FIELD_FLAGS_REQUIRED,
];
